import Vue from 'vue';
import AuthProxy from '@/store/proxies/auth-proxy';
import UserProxy from '@/store/proxies/user-proxy';
import AccountProxy from '@/store/proxies/account-proxy';
import LicenseProxy from '@/store/proxies/license-proxy';
import { resetUserClockSkewCheck, runClockSkewCheckForNewLoginSession } from '@/utils/clock-skew';
import * as types from './mutation-types';

/* ============
 * Actions for the auth module
 * ============
 *
 * The actions that are available on the
 * auth module.
 */

const onSuccess = (commit, resolve, actionType) => (result) => {
  commit(actionType, result);
  resolve(result);
};

export const check = ({ commit }) => {
  commit(types.CHECK);
};

function toNextRoute() {
  const originalRoute = JSON.parse(localStorage.getItem('originalRoute'));
  const nextRoute = {
    name: originalRoute ? originalRoute.name : 'main.dashboard',
  };
  localStorage.removeItem('originalRoute');
  Vue.router.push(nextRoute);
}

export const login = ({ commit }, payload) => new Promise((resolve, reject) => {
  new AuthProxy()
    .login(payload)
    .then((response) => {
      commit(types.LOGIN, response);
      resolve(response);
      runClockSkewCheckForNewLoginSession();
      toNextRoute();
    })
    .catch((errors) => {
      reject(errors);
    });
});

export const refresh = ({ commit, dispatch }) => new Promise((resolve, reject) => {
  const refreshToken = localStorage.getItem('refresh_token');
  if (refreshToken) {
    new AuthProxy().refresh(refreshToken).then((response) => {
      commit('REFRESH', response);
      resolve(response);
      location.reload();
    });
  } else {
    reject(true);
    dispatch('logout');
  }
});

export const logout = ({ commit }) => {
  resetUserClockSkewCheck();
  commit(types.LOGOUT);
  Vue.router.push({
    name: 'login',
    params: { type: 'logout' },
  });
};

export const register = ({ commit }, payload) => new Promise((resolve, reject) => {
  new AccountProxy().register(payload).then(res => resolve(res)).catch((e) => {
    reject(e);
  });
});

export const forgotPassword = ({ commit }, payload) => new Promise((resolve, reject) => {
  new UserProxy().forgotUserPassword(payload).then(res => resolve(res)).catch(e => reject(e));
});

export const recoveryPassword = ({ commit }, payload) => new Promise((resolve, reject) => {
  new UserProxy().recoveryPassword(payload).then(res => resolve(res)).catch(e => reject(e));
});

export const updateCompanyInfo = ({ commit }, payload) => new Promise((resolve, reject) => {
  new AccountProxy().update(payload).then((res) => {
    commit(types.UPDATE_COMPANY_INFO, {
      ...payload,
      is_temporary: false,
    });
    return resolve(res);
  }).catch(e => reject(e));
});

export const updateCompanyTaxAccount = ({ commit }, payload) => new Promise((resolve, reject) => {
  new AccountProxy().updateTaxAccount(payload).then(res => resolve(res)).catch(e => reject(e));
});

export const updateUserProfile = ({ commit }, payload) => new Promise((resolve) => {
  const userProxy = new UserProxy();
  userProxy.updateUserInfo({
    name: payload.name,
    phone: payload.phone,
  }).then(onSuccess(commit, resolve, types.UPDATE_USER_PROFILE));
  if (payload.password) {
    userProxy.setUserPassword({
      old_password: payload.old_password,
      new_password: payload.password,
    });
  }
});

export const updateEInvoiceRole = ({ commit }, payload) => {
  commit(types.UPDATE_E_INVOICE_ROLE, payload);
};

export const updateLicense = ({ commit }, payload) => {
  commit(types.UPDATE_LICENSE, payload);
};

export const getSubscriptionsMonitor = ({ commit }) => new Promise((resolve) => {
  const userInfor = JSON.parse(localStorage.getItem('currentUser'));
  if (!userInfor || !userInfor.company || !userInfor.company.company_id) return;
  const parameters = {
    company_id: userInfor.company.company_id,
    service: 'EINVOICE',
  };
  new LicenseProxy(parameters).getSubscriptionsMonitor().then(onSuccess(commit, resolve, types.GET_SUBSCRIPTIONS_MONITOR));
});

export default {
  check,
  register,
  refresh,
  login,
  logout,
  updateCompanyInfo,
  updateCompanyTaxAccount,
  updateUserProfile,
  forgotPassword,
  recoveryPassword,
  updateLicense,
  updateEInvoiceRole,
  getSubscriptionsMonitor,
};



// WEBPACK FOOTER //
// ./src/store/modules/auth/actions.js